// Temporary interop for pages whose layout Grid is `@mui/material` but whose children
// still render the legacy Material-UI v4 Grid (`@material-ui/core/Grid`, e.g.
// components/Images or the reservations Invoice card).
//
// While a v4 Grid is mounted, its stylesheet targets the same global `.MuiGrid-*` class
// names that the `@mui/material` Grid emits, so v4's negative margins,
// `width: calc(100% + Npx)` and fixed `flex-basis`/`max-width` land on the page grid and
// break its gap-based layout. `&&` doubles the specificity so these values win over the
// leaked v4 rules regardless of stylesheet order.
//
// Use `legacyGridSafeContainerSx` on `<Grid container spacing>` and `legacyGridSafeItemSx`
// on sized columns (`size={{ md: 4 }}` and similar). Full-width `size={12}` items do not
// need it.
//
// Remove this file and its usages once no `@material-ui/core/Grid` import is left in src/.

export const legacyGridSafeContainerSx = { '&&': { margin: 0, width: '100%' } };

export const legacyGridSafeItemSx = { '&&': { flexBasis: 'auto', maxWidth: 'none' } };
